import React from 'react';

const AsyncSpeakerPage = React.lazy(() => import('./SpeakerContainer'));

export const SpeakerPage = () => <AsyncSpeakerPage />;
